import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export function PortfolioRedirect() {
  const navigate = useNavigate();
  const { slug } = useParams();

  useEffect(() => {
    const target = slug ? `/work/${slug}` : "/work";
    navigate(target, { replace: true });
  }, [navigate, slug]);

  return null;
}
